/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Physical_Reward_PlaceholderInputs */

const en_plan_physical_reward_placeholder = /** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 1x signed print, Limited edition socks...`)
};

const es_plan_physical_reward_placeholder = /** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. 1x impresión firmada, calcetines de edición limitada...`)
};

const fr_plan_physical_reward_placeholder = /** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. 1x impression signée, Chaussettes en édition limitée...`)
};

const de_plan_physical_reward_placeholder = /** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. 1x signierter Druck, Limitierte Socken...`)
};

const id_plan_physical_reward_placeholder = /** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. 1x cetakan bertanda tangan, Kaus kaki edisi terbatas...`)
};

/** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */
const ja_plan_physical_reward_placeholder = en_plan_physical_reward_placeholder;

/** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */
const zh_plan_physical_reward_placeholder = en_plan_physical_reward_placeholder;

/** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */
const ar_plan_physical_reward_placeholder = en_plan_physical_reward_placeholder;

/** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */
const it_plan_physical_reward_placeholder = en_plan_physical_reward_placeholder;

/** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */
const ru_plan_physical_reward_placeholder = en_plan_physical_reward_placeholder;

/** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */
const pt_plan_physical_reward_placeholder = en_plan_physical_reward_placeholder;

/** @type {(inputs: Plan_Physical_Reward_PlaceholderInputs) => LocalizedString} */
const ko_plan_physical_reward_placeholder = en_plan_physical_reward_placeholder;

/**
* | output |
* | --- |
* | "e.g. 1x signed print, Limited edition socks..." |
*
* @param {Plan_Physical_Reward_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const plan_physical_reward_placeholder = /** @type {((inputs?: Plan_Physical_Reward_PlaceholderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Physical_Reward_PlaceholderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plan_physical_reward_placeholder(inputs)
	if (locale === "es") return es_plan_physical_reward_placeholder(inputs)
	if (locale === "fr") return fr_plan_physical_reward_placeholder(inputs)
	if (locale === "de") return de_plan_physical_reward_placeholder(inputs)
	if (locale === "ja") return ja_plan_physical_reward_placeholder(inputs)
	if (locale === "zh") return zh_plan_physical_reward_placeholder(inputs)
	if (locale === "ar") return ar_plan_physical_reward_placeholder(inputs)
	if (locale === "id") return id_plan_physical_reward_placeholder(inputs)
	if (locale === "it") return it_plan_physical_reward_placeholder(inputs)
	if (locale === "ru") return ru_plan_physical_reward_placeholder(inputs)
	if (locale === "pt") return pt_plan_physical_reward_placeholder(inputs)
	return ko_plan_physical_reward_placeholder(inputs)
});